<template>
  <div class="search-container">
    <FilterConditions
      v-if="isShowConditions"
      v-model="conditions"
      :searchData="searchData"
      @empty="empty"
      @clearItem="clearItem"
    />
    <div
      class="item-wrapper"
      v-for="(item, index) in searchData.filter(x =>
        form.showMode === 'MAP' ? !mapModeNotField.includes(x.field) : true
      )"
      :key="index"
    >
      <!-- Tag相关筛选项 -->
      <template
        v-if="
          item &&
          !item.isFormList &&
          !item.isTableList &&
          item.options &&
          item.options.length
        "
      >
        <span v-if="item.label">{{ item.label }}</span>
        <component
          :key="index"
          ref="compdom"
          :is="item.name"
          :label="item.label"
          :value="item.defaultValue"
          :options="item.options"
          :field="item.field"
          :isForm="item.isForm"
          :childField="item.childField"
          :dynamicChildField="item.dynamicChildField"
          :cssstyle="item.style"
          :isCondition="item.notCondition"
          :itemData="item"
          @click="searchClick"
          @initFormData="initFormData"
        />
      </template>
      <!-- Form表单相关筛选项 -->
      <template
        v-if="
          item &&
          item.isFormList &&
          item.options &&
          item.options.length &&
          item.options.some(x => x.isHide === false)
        "
      >
        <span v-if="item.label">{{ item.label }}</span>
        <component
          ref="compdom"
          :is="item.name"
          :isForm="!!item.isFormList"
          v-for="(form, index) in item.options.filter(
            x => x.options && x.options.length && !x.isHide
          )"
          :key="index"
          :placeholder="form.placeholder"
          :value="form.defaultValue"
          :options="form.options"
          :field="form.field"
          :cssstyle="form.style"
          :isCondition="item.notCondition"
          @click="searchClick"
          @initFormData="initFormData"
        />
      </template>
      <!-- 列表筛选 -->
      <template
        v-if="item && item.isTableList && item.options && item.options.length"
      >
        <div
          class="item-card"
          :class="
            item.options.some(x => x.options && x.options.length)
              ? ''
              : 'item-card-hide'
          "
        >
          <div class="current-position" v-if="form.showMode === 'MAP'">
            <span>我的位置：{{ currentPosition.address }}</span>
            <img
              class="positoin-icon"
              src="@/assets/public/map_point.png"
              @click="clickCurrentPoint"
            />
          </div>
          <component
            v-for="(tableSort, index) in item.options.filter(x =>
              form.showMode === 'MAP'
                ? !mapModeNotField.includes(x.field)
                : true
            )"
            ref="compdom"
            :is="tableSort.name"
            :isCard="item.isTableList"
            :key="index"
            :value="tableSort.defaultValue"
            :options="tableSort.options"
            :field="tableSort.field"
            :cssstyle="tableSort.style"
            :isCondition="tableSort.notCondition"
            @click="searchClick"
            @initFormData="initFormData"
          />
          <DisplayMode :cardVal="cardVal" @changeMode="changeMode" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Template from "./template"
import { MODE_ENUM } from "./template/constant"
export default {
  name: "FilterSearch",
  components: {
    ...Template,
    FilterConditions: () => import("./components/filterConditions.vue"),
    DisplayMode: () => import("./components/DisplayMode.vue")
  },
  model: {
    prop: "searchData",
    event: "change"
  },
  props: {
    isShowConditions: {
      type: Boolean,
      default: true
    },
    searchData: {
      // 搜索条件配置
      type: Array,
      default: () => []
    },
    defaultForm: {
      // 表单初始化默认字段
      type: Object,
      default: () => ({})
    },
    initNumber: {
      // 第一次初始化dom次数
      type: Number,
      default: 0
    },
    mapModeNotField: {
      // 地图模式不展示的选项
      type: Array,
      default: () => []
    },
    currentPosition: {
      // 当前定位
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      conditions: [], // 筛选条件
      form: {},
      cardVal: [],
      initIndex: 0,
      defFilterProvince: null, // 记录定位省份
		  currentCilckProvince: null // 记录当前点击省份
    }
  },
  mounted() {},
  methods: {
    // 初始化form所有字段和默认值
    initFormData(data) {
      this.initIndex += 1
      const { field, val, isCondition, isOldType } = data
      this.form[field] = val
      this.setOldTypeField(data)
      !isCondition && this.changeConditions(data)
      if (this.initIndex === this.initNumber) {
        const formData = this.form
        this.form = { ...this.defaultForm, ...formData }
        this.initMode()
        this.$emit("searchChange", { data: null, form: this.form })
      }
    },
    setOldTypeField(data) {
      const { field, isOldType } = data
      if (isOldType) {
        this.form["oldTypeField"] = field
      } else {
        if (this.form["oldTypeField"] && this.form["oldTypeField"] === field) {
          this.form["oldTypeField"] = ""
        }
      }
    },
    // 更改项触发
    searchClick(data) {
      const { field, val, isCondition, isForm } = data
      this.form[field] = val
      this.setOldTypeField(data)
      !isForm && this.empty(data) // 不限|全国 清空当前项及所有子集联动值(排除已经清空了的，排除form表单-form表单存在不限选中问题)
      !isCondition && this.changeConditions(data)
      data.field === "tenderMothed" && this.initMode()
      this.$emit("searchChange", { data, form: this.form })
    },
    // 获取当前定位
    clickCurrentPoint() {
      this.$emit("getCurPosition")
    },
    // 初始化列表展示模式
    initMode() {
      // 默认为卡片展示模式
      this.form["showMode"] = "CARD"
      const { tenderMothed, showMode } = this.form
      this.searchData.map(x => {
        if (x.field === "keyword") {
          if (x.showSearchMode.includes("CARD")) {
            x.options = ["CARD"]
          } else {
            x.options = []
          }
        }
      })
      const list = MODE_ENUM[`${showMode}_${tenderMothed}`]
      this.cardVal = tenderMothed && list ? list : []
    },
    // 列表模式改变
    changeMode(mode, isClick = true) {
      this.form["showMode"] = mode
      const { tenderMothed } = this.form
      //tenderMothed:招标公告-1 动态竞价-2 招标预告-3 需求预算-4
      this.cardVal = tenderMothed ? MODE_ENUM[`${mode}_${tenderMothed}`] : []
      this.searchData.map(x => {
        if (x.field === "keyword") {
          if (x.showSearchMode.includes(mode)) {
            x.options = [mode]
          } else {
            x.options = []
          }
        }
      })
      isClick && this.$emit("searchChange", { data: null, form: this.form })
    },
    // 筛选条件列表修改
    changeConditions(data) {
    this.isShowConditions=true
		let arr = JSON.parse(JSON.stringify(this.conditions))
      const { field, childField, val, resetDefvalueField } = data
      if (!this.defFilterProvince && field === "province") {
        this.defFilterProvince = data
      }
      if(field === 'province' && val) { // 当前点击省份记录
			this.currentCilckProvince = data
		}
		const i = arr.findIndex(x => x.field === field)
		const current = arr[i]
		if(resetDefvalueField) { // 存在特殊筛选条件处理配置
			const { dycField, isNotSetDefaultVal } = resetDefvalueField
			if(current) { // 当前项存在
				if(data.val !== current.val) { // 点击tag和当前值不相等
					if(data.name !== '不限' && data.name !== '全国') { // 不为不限 - 替换操作
						// 替换新的data
						arr.splice(i, 1, data)

					} else { // 不限｜全国
						if(childField && childField.length) {
							arr = arr.filter(x => {
								return !childField.includes(x.field) && x.field !== field
							})
						} else { // 没有子集 - 过滤掉当前
							arr = arr.filter(x => x.field !== field)
						}
					}
				}
			} else { // 当前项不存在 -- 追加
				if(data.name !== '不限' && data.name !== '全国') {
					arr.push(data)
				}
			}
			if(isNotSetDefaultVal.includes(+val)) { // 点击当前项中-不设置初始化值字段
				arr = arr.filter(x => x.field !== dycField)
			} else {
				if(arr && arr.length) {
					const arr1 = arr.filter(x => x.field !== dycField)
					const provinceData = this.form[dycField] === this.defFilterProvince.val ? this.defFilterProvince : this.currentCilckProvince
					arr = !this.form[dycField] ? arr1 : [provinceData, ...arr1]
				}
			}
			this.conditions = arr
      if(this.conditions.length==0){
        this.isShowConditions=false
      }
		} else { // 不存在特殊条件
			if(current) { // 当前项存在
				if(data.val !== current.val) { // 点击tag和当前值不相等
					if(data.name !== '不限' && data.name !== '全国') { // 不为不限 - 替换操作
						// 替换新的data
						arr.splice(i, 1, data)
						if(childField && childField.length) {
							arr = arr.filter(x => {
								return !childField.includes(x.field)
							})
						} 
					} else { // 不限｜全国
						if(childField && childField.length) {
							arr = arr.filter(x => {
								return !childField.includes(x.field) && x.field !== field
							})
						} else { // 没有子集 - 过滤掉当前
							arr = arr.filter(x => x.field !== field)
						}
					}
				}
			} else { // 当前项不存在 -- 追加
				if(data.name !== '不限' && data.name !== '全国') {
					arr.push(data)
				}
			}
			this.conditions = arr
      if(this.conditions.length==0){
        this.isShowConditions=false
      }
		}
    },
    // 清除当前筛选条件
    clearItem(data) {
      this.setOldTypeField(data)
      const { isCondition } = data
      !isCondition && this.changeConditions(data)
      this.$emit("searchChange", { data: null, form: this.form })
    },
    // 清空
    empty(data) {
      if (data) {
        // 单个选项清空
        this.$refs.compdom.map(item => {
          if (item.field === data.field) {
            item.initValue = data.val
            this.form[data.field] = data.val
            const { childField, val } = data
            if (childField) {
              this.$refs.compdom.map(x => {
                if (childField.includes(x.field)) {
                  // 子集字段清空｜重置
                  x.initValue = x.value || "" // 联动项筛清空
                  this.form[x.field] = x.value || ""
                  this.searchData.map((y, i) => {
                    if (childField.includes(y.field)) {
                      y.options = []
                    }
                  })
                } else {
                  const { resetDefvalueField = undefined } = data
                  if (
                    resetDefvalueField &&
                    resetDefvalueField.dycField == x.field
                  ) {
                    if (resetDefvalueField.isNotSetDefaultVal.includes(+val)) {
                      x.initValue = ""
                      this.form[x.field] = ""
                      this.searchData.map(y => {
                        if (x.childField.includes(y.field)) {
                          y.options = []
                        }
                      })
                    } else {
                      x.initValue = x.value || ""
                      this.form[x.field] = x.value || ""
                    }
                  }
                }
              })
            }
          }
        })
        // this.changeMode(this.form.showMode, false)
      } else {
        // 全部清空
        this.$refs.compdom.map(item => {
          const notReset = ["dataSources", "sortMethod"]
          if (!notReset.includes(item.field)) {
            item.initValue = ""
            this.form[item.field] = ""
          }
          if (
            this.mapModeNotField.includes(item.field) &&
            !notReset.includes(item.field)
          ) {
            item.initValue = ""
            this.form[item.field] = ""
          }
        })
        // 数据初始化展示处理
        const resetList = this.searchData.map(x => {
          if (x.isFormList) {
            // Form表单项
            const formList = x.options.map(formItem => {
              return {
                ...formItem,
                isHide: !formItem.isInitShow
              }
            })
            return {
              ...x,
              options: formList
            }
          } else if (x.isTableList) {
            // Table筛选项
            return x
          } else {
            // Tag筛选项
            if (x.isInitShow) {
              return x
            } else {
              return {
                ...x,
                options: []
              }
            }
          }
        })
        this.$emit("change", resetList) // 重置数据
        this.changeMode("CARD", false)
        // 清空所有
        this.$emit("searchChange", { data: null, form: this.form })
        this.isShowConditions=false
      }
    },
    getFormData() {
      return this.form
    }
  }
}
</script>

<style lang="scss" scoped>
.search-container {
  position: relative;
  width: 1198px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-bottom: none;
  .item-wrapper {
    display: flex;
    position: relative;
    > span {
      display: flex;
      width: 130px;
      justify-content: center;
      color: #666;
      padding-top: 15px;
      background: #f5f7fa;
      margin-right: 20px;
      font-size: 14px;
    }
    .item-card {
      &.item-card-hide {
        height: 0;
        overflow: hidden;
      }
      padding-left: 30px;
      display: flex;
      height: 50px;
      align-items: center;
      flex: 1;
      margin-top: 10px;
      border-bottom: 1px solid #e4e7ed;
      .current-position {
        flex: 1;
        display: flex;
        align-items: center;
        span {
          font-size: 14px;
          color: #333;
        }
        img {
          width: 22px;
          cursor: pointer;
          margin-left: 10px;
        }
      }
      &::before {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        height: 10px;
        background: #f5f5f5;
        content: "";
        border-top: 1px solid #e4e7ed;
        border-bottom: 1px solid #e4e7ed;
        z-index: 1;
      }
    }
  }
}
</style>
